module.exports = __webpack_public_path__ + "img/profit-and-loss.d627cc32.png";